import { Link } from "@tanstack/react-router";
import { ResourceType } from "@/queries/control-monitor";

function IntegrationsSyncLink() {
  return (
    <Link to="/account/integrations" className="underline underline-offset-2">
      sync integrations
    </Link>
  );
}

export function SCMEmptyState({
  resourceType,
}: {
  resourceType: ResourceType;
}) {
  return (
    <span className="truncate">
      There are no results to display at this time. Please add{" "}
      {resourceType === "user" ? "a" : "an"} {resourceType}, select a different
      filter, or <IntegrationsSyncLink />
    </span>
  );
}

export function SCMPolicyEmptyState() {
  return (
    <span className="truncate">
      There are no results to display at this time. Please add a policy, select
      a different filter, or <IntegrationsSyncLink />
    </span>
  );
}
